import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
// import { MatButtonModule, MatCheckboxModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { Contactos2Service } from './contactos2.service';
import { Contactos2Component, DialogDataExampleDialogComponent } from './contactos2.component';
import {HttpClientModule} from '@angular/common/http';
import {HttpModule} from '@angular/http';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatIconModule, MatInputModule, MatSlideToggleModule, MatToolbarModule } from '@angular/material';
import { FuseConfirmDialogModule } from '@fuse/components';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
const routes = [
    {
        path     : 'contactos2',
        component: Contactos2Component
    }
];

@NgModule({
    declarations: [
        Contactos2Component,
        DialogDataExampleDialogComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        SweetAlert2Module,
        MatIconModule,
        TranslateModule,
        NgxLoadingModule,
        AgGridModule.withComponents([]),
        FuseSharedModule,
        HttpClientModule, HttpModule,
        FuseConfirmDialogModule,
        
        
        NgxMatSelectSearchModule,
        MatSelectModule,
    MatToolbarModule,
    MatFormFieldModule
   
    
    ],
    exports     : [
        Contactos2Component
    ],
    providers: [Contactos2Service],
    entryComponents: [DialogDataExampleDialogComponent],

 
})

export class Contactos2Module
{
}
